import favoriteFilled from "@iconify/icons-mdi/heart";
import favoriteBorder from "@iconify/icons-mdi/heart-outline";
import { Icon } from "@iconify/react";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import {
  Avatar,
  Box,
  Chip,
  CircularProgress,
  Container,
  Divider,
  Grid,
  IconButton,
  Rating,
  Skeleton,
  Typography,
} from "@mui/material";
import { useSnackbar } from "notistack";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  isProductLiked,
  likeProduct,
  unlikeProduct,
} from "../../store/reducers/userReducer";
import ProductCard from "./ProductCard.jsx";
import magicChat from "./magicChat.svg";
import NearbyStores from "./nearbyStores/products.nearbyStores.jsx";
import OnlineStores from "./onlineStores/products.onlineStores.jsx";

import ProductSkeletonLarge from "./skeletons/Products.skeleton.detailsLarge.jsx";
// let product = {
//   name: "Pentel Hi-Polymer Eraser Large Nonabrasive White ZEH10",
//   rating: 4.5,
//   description:
//     "Pentel Hi-Polymer latex-free erasers leave a clean sheet with very little pressure. Pentel Hi-Polymer latex-free erasers are nontoxic for school use. These high-quality everyday erasers keep pages clean and free of damage thanks to latex-free polyvinyl chloride that doesn t get brittle or harden over time. With very little pressure the eraser removes pencil marks without leaving behind any dust or debris making pages easier to read without any smudges on them. Large erasers fit easily into small hands so kids have a better time erasing any wayward pencil marks. • Block-style white eraser to use in school or work. • Everyday use for pencil marks. • Pack of one eraser. • Certified nontoxic for school use. • No smudges no paper tears and no ghosting. • Doesn t crack or harden with age; remains soft and ready to use. • Eraser always looks clean - black color hides the lead residue. • Eraser should be used and stored with protective sleeve. • AP certified nontoxic. • 1 eraser per pack. • White. • Size: Large. • Latex-free. • Material: Polymer. • Sold as each. • Erases cleanly. • Non-abrasive. Easy to Use The eraser doesn t leave behind any dust nor does it damage the paper due to high-quality materials and a very light pressure needed to erase pencil marks. This is ideal for writing or artwork that needs a delicate touch without leaving behind a mess. Long-Lasting Less pressure on the eraser helps it to last longer while kids don t spend a lot of time erasing their pencil marks. The latex-free polyvinyl chloride doesn t harden or crack with age and it remains soft and ready-to-use at any time. Use and store this eraser with its protective sleeve to ensure its longevity flexibility and high-quality erasing capabilities. Ideal for Kids Pentel s Hi-Polymer eraser is certified nontoxic so children can use it for everyday schoolwork that requires a pencil. Think spelling tests artwork with colored pencils and spontaneous quizz.",
//   ingredients: null,
//   image: "https://images.barcodelookup.com/1102/11026068-1.jpg",
//   onlineStores: [
//     {
//       name: "Zoro",
//       price: "$1.49",
//       url: "https://www.zoro.com/c/i/G7485919/",
//     },
//     {
//       name: "Target",
//       price: "$2.19",
//       url: "https://www.target.com/p/pentel-hi-polymer-erasers-4ct/-/A-13296292",
//     },
//     {
//       name: "Office Depot and OfficeMax",
//       price: "$1.69",
//       url: "https://www.officedepot.com/a/products/772089/Pentel-Hi-Polymer-Eraser-Lead-Pencil/",
//     },
//     {
//       name: "Staples",
//       price: "$1.69",
//       url: "https://www.staples.com/pentel-hi-polymer-latex-free-eraser-each-zeh-10/product_PENZEH10?cid=BNR:PENZEH10",
//     },
//     {
//       name: "GoVets",
//       price: "$1.79",
//       url: "https://www.govets.com/pentel-312-772089.html?",
//     },
//     {
//       name: "Quill",
//       price: "$3.99",
//       url: "https://www.quill.com/mcode?m=AFF_PRD_012803",
//     },
//   ],
//   upc: "072512027660",
//   classifications: ["Office Supplies", "General Office Supplies", "Erasers"],
//   relatedPrompts: [
//     "Can you help me find a juice that's rich in antioxidants? ",
//     "What's a good juice for immunity?",
//     "Do you have any juices that are organic and made with natural ingredients?",
//     "I want a juice that's kid-friendly and nutritious. What do you recommend?",
//     " Best juice for energy?",
//   ],
//   reviews: [
//     {
//       name: "Ronti Jordan",
//       rating: 4.5,
//       review:
//         "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
//       likes: 24,
//       date: "12 Days ago",
//     },
//     {
//       name: "Ronti Jordan",
//       rating: 4.5,
//       review:
//         "Aliqua officia duis occaecat consectetur furgiat nostrud anim dolor commado officiaproident. Voluptate nisi reprehenderit.",
//       likes: 24,
//       date: "12 Days ago",
//     },
//     {
//       name: "Ronti Jordan",
//       rating: 4.5,
//       review:
//         "Aliqua officia duis occaecat consectetur furgiat nostrud anim dolor commado officiaproident. Voluptate nisi reprehenderit.",
//       likes: 24,
//       date: "12 Days ago",
//     },
//   ],
//   found: true,
// };


let productTest = {
  name: "Pentel Hi-Polymer Eraser Large Nonabrasive White ZEH10",
  rating: 4.5,
  description:
    "Pentel Hi-Polymer latex-free erasers leave a clean sheet with very little pressure. Pentel Hi-Polymer latex-free erasers are nontoxic for school use. These high-quality everyday erasers keep pages clean and free of damage thanks to latex-free polyvinyl chloride that doesn t get brittle or harden over time. With very little pressure the eraser removes pencil marks without leaving behind any dust or debris making pages easier to read without any smudges on them. Large erasers fit easily into small hands so kids have a better time erasing any wayward pencil marks. • Block-style white eraser to use in school or work. • Everyday use for pencil marks. • Pack of one eraser. • Certified nontoxic for school use. • No smudges no paper tears and no ghosting. • Doesn t crack or harden with age; remains soft and ready to use. • Eraser always looks clean - black color hides the lead residue. • Eraser should be used and stored with protective sleeve. • AP certified nontoxic. • 1 eraser per pack. • White. • Size: Large. • Latex-free. • Material: Polymer. • Sold as each. • Erases cleanly. • Non-abrasive. Easy to Use The eraser doesn t leave behind any dust nor does it damage the paper due to high-quality materials and a very light pressure needed to erase pencil marks. This is ideal for writing or artwork that needs a delicate touch without leaving behind a mess. Long-Lasting Less pressure on the eraser helps it to last longer while kids don t spend a lot of time erasing their pencil marks. The latex-free polyvinyl chloride doesn t harden or crack with age and it remains soft and ready-to-use at any time. Use and store this eraser with its protective sleeve to ensure its longevity flexibility and high-quality erasing capabilities. Ideal for Kids Pentel s Hi-Polymer eraser is certified nontoxic so children can use it for everyday schoolwork that requires a pencil. Think spelling tests artwork with colored pencils and spontaneous quizz.",
  ingredients: null,
  image: "https://images.barcodelookup.com/1102/11026068-1.jpg",
  onlineStores: [
    {
      name: "Zoro",
      price: "$1.49",
      url: "https://www.zoro.com/c/i/G7485919/",
    },
    {
      name: "Target",
      price: "$2.19",
      url: "https://www.target.com/p/pentel-hi-polymer-erasers-4ct/-/A-13296292",
    },
    {
      name: "Office Depot and OfficeMax",
      price: "$1.69",
      url: "https://www.officedepot.com/a/products/772089/Pentel-Hi-Polymer-Eraser-Lead-Pencil/",
    },
    {
      name: "Staples",
      price: "$1.69",
      url: "https://www.staples.com/pentel-hi-polymer-latex-free-eraser-each-zeh-10/product_PENZEH10?cid=BNR:PENZEH10",
    },
    {
      name: "GoVets",
      price: "$1.79",
      url: "https://www.govets.com/pentel-312-772089.html?",
    },
    {
      name: "Quill",
      price: "$3.99",
      url: "https://www.quill.com/mcode?m=AFF_PRD_012803",
    },
  ],
  upc: "072512027660",
  classifications: ["Office Supplies", "General Office Supplies", "Erasers"],
  relatedPrompts: [
    "Can you help me find a juice that's rich in antioxidants? ",
    "What's a good juice for immunity?",
    "Do you have any juices that are organic and made with natural ingredients?",
    "I want a juice that's kid-friendly and nutritious. What do you recommend?",
    " Best juice for energy?",
  ],
  reviews: [
    {
      name: "Ronti Jordan",
      rating: 4.5,
      review:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
      likes: 24,
      date: "12 Days ago",
    },
    {
      name: "Ronti Jordan",
      rating: 4.5,
      review:
        "Aliqua officia duis occaecat consectetur furgiat nostrud anim dolor commado officiaproident. Voluptate nisi reprehenderit.",
      likes: 24,
      date: "12 Days ago",
    },
    {
      name: "Ronti Jordan",
      rating: 4.5,
      review:
        "Aliqua officia duis occaecat consectetur furgiat nostrud anim dolor commado officiaproident. Voluptate nisi reprehenderit.",
      likes: 24,
      date: "12 Days ago",
    },
  ],
  found: true,
};
// { product , similarProducts }
const DetailsLarge = ({ product, similarProducts, additonalProductsError }) => {
  const navigate = useNavigate();
  const { id } = useParams();
  console.log(id);
  console.log(product);
  const [search, setSearch] = useState("");
  const [showFullDescription, setShowFullDescription] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const [loadingProductId, setLoadingProductId] = useState(null);
  const snackbar = useSnackbar();
  const [sliceSize, setSliceSize] = useState(2);
  const [showMore, setShowMore] = useState(false);
  const [loading, setLoading] = useState(false);
  const [reviews, setReviews] = useState([]);
  const hasFetchedReviews = useRef(false);

  const dispatch = useDispatch();
  const user = useSelector((state) => state.user.user);
  const isLiked = useSelector((state) =>
    isProductLiked(state.user.user, product.upc)
  );

  const getProductReviews = async () => {
    try {
      const response = await axios.post("/reviews/openai", {
        product: product,
        upc: id,
      });
      console.log("reviews: ", response.data);
      setReviews(response.data);
      hasFetchedReviews.current = true;
    } catch (error) {
      console.log("error getting reviews: ", error);
    }
  };
  useEffect(() => {
    if (product && product.name) {
      getProductReviews();
    }
  }, [product]);

  const handleLikeClicked = (e) => {
    e.stopPropagation();
    const skeletonProduct = {
      title: product.name,
      image: product.image,
      upc: product.upc,
    };

    if (!user || !user.token) {
      snackbar.enqueueSnackbar("Please log in to like products!", {
        variant: "error",
        autoHideDuration: 2000,
      });
      return;
    }

    if (isLiked) {
      dispatch(unlikeProduct({ product: skeletonProduct }));
    } else {
      dispatch(likeProduct({ product: skeletonProduct }));
    }
  };

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
  };
  function removeLeadingZeros(upc) {
    return upc.replace(/^0+/, '');
  }

  const handleSeeMoreToggle = () => {
    setExpanded(!expanded);
    if (expanded) {
      setSliceSize(2);
    } else {
      setSliceSize(5);
    }
  };
  return (
    <Container
      disableGutters
      maxWidth={false}
      sx={{
        backgroundColor: "white",
        minHeight: "200vh",
        height: "auto",
        display: "flex",
        flexDirection: "column",
        paddingRight: 1,
      }}
    >
      {removeLeadingZeros(product.upc) === removeLeadingZeros(id) ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            alignItems: "center",
            width: "100%",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center", // Keeps title centered
              width: "100%",
              padding: "16px 32px",
              paddingTop: "60px",
              position: "sticky",
              top: 0,
              backgroundColor: "white",
              zIndex: 10,
            }}
          >
            {/* Back Button (Left-Aligned) */}
            <IconButton
              size="medium"
              sx={{
                color: "black",
                position: "absolute",
                left: 32, // Ensures back button stays on the left
              }}
              onClick={() => navigate("/products/")}
            >
              <ArrowBackIosNewIcon fontSize="medium" />
            </IconButton>
          </Box>

          <Box
            sx={{
              maxWidth: "1225px",
              width: "100%",
              display: "flex",
              justifyContent: "center",
              paddingTop: "20px",
            }}
          >
            <Box
              sx={{
                width: "100%",
                display: "flex",
                justifyContent: "start",
                flexDirection: "row",
                gap: 5,
              }}
            >
              <Box sx={{ maxWidth: "330px" }}>
                <img
                  src={
                    product.image
                      ? product.image
                      : `https://placehold.co/800x400?text=${product.name}`
                  }
                  style={{ maxHeight: "30vh", maxWidth: "30vh" }}
                  alt={`${product.name}`}
                />
              </Box>
              <Box
                sx={{
                  width: "70%",
                }}
              >
                <Box mt={1}>
                  {product.classifications &&
                    product.classifications.map((classification, index) => (
                      <Chip
                        key={index}
                        label={classification}
                        size="small"
                        sx={{ mr: 1, mb: 0.5 }}
                      />
                    ))}
                </Box>
                <Typography
                  variant={"h4"}
                  sx={{
                    fontWeight: 500,
                  }}
                >
                  {product.name}
                </Typography>
                <Box sx={{ display: "flex", flexDirection: "row", gap: 4 }}>
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Rating
                      value={Number(product.rating)}
                      precision={0.5}
                      readOnly
                    />
                    <Typography
                      variant="body2"
                      color="textSecondary"
                      onClick={() => navigate(-1)}
                      sx={{
                        ml: 1,
                        underline: "hover",
                        color: "#15224F",
                        cursor: "pointer",
                      }}
                    >
                      {product.rating} {/* can add later if we want to */}
                      {/* <span style={{ color: "#15224F" }}>(See More)</span> */}
                    </Typography>
                  </Box>
                  <Box>
                    <IconButton
                      onClick={(e) => handleLikeClicked(e)}
                      sx={{
                        "&:hover": { borderRadius: 6 },
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                      }}
                      disabled={!product.found}
                    >
                      {product.found && (
                        <Icon
                          icon={isLiked ? favoriteFilled : favoriteBorder}
                          fontSize="large"
                          style={{
                            color: isLiked ? "#EF4F26" : "#99B2C3",
                            scale: "1.5",
                          }}
                        />
                      )}
                      <Typography
                        sx={{
                          fontWeight: 550,
                          color: "#205375",
                          fontSize: "16px",
                          lineHeight: 2,
                        }}
                      >
                        Favorite
                      </Typography>
                    </IconButton>
                  </Box>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    gap: 2,
                    paddingTop: "20px",
                  }}
                >
                  <IconButton
                    sx={{
                      width: "121px",
                      height: "53px",
                      borderRadius: "30px",
                      background: "#EF4F26",
                      gap: 1,
                      "&:hover": {
                        background: "#EF4F26",
                        opacity: 1,
                      },
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      console.log("Chat icon clicked");
                      navigate(`/products/chat/${product.upc}`);
                    }}
                  >
                    <img src={magicChat} style={{ color: "#FFFFFF" }} />
                    <Typography variant="h6" sx={{ color: "white" }}>
                      Ask
                    </Typography>
                  </IconButton>
                  <NearbyStores product={product} />
                  <OnlineStores product={product}/>
                </Box>
                <Box
                  sx={{
                    pt: 2,
                    display: "flex",
                    flexDirection: "column",
                    gap: 1,
                  }}
                >
                  <Typography variant="h5" color="#15224F">
                    Description
                  </Typography>
                  <Typography variant="h9">
                    {product.description && (
                      <Box>
                        <Typography
                          variant="body2"
                          color="textSecondary"
                          paragraph
                          textAlign="left"
                          sx={{
                            display: "inline",
                            marginRight: "5px",
                          }}
                        >
                          {product.description.slice(
                            0,
                            showFullDescription ? undefined : 230
                          )}
                          {!showFullDescription &&
                            product.description.length > 230 &&
                            "..."}
                        </Typography>
                        {product.description.length > 230 && (
                          <Typography
                            variant="body2"
                            color="primary"
                            onClick={() =>
                              setShowFullDescription(!showFullDescription)
                            }
                            sx={{ cursor: "pointer", display: "inline" }}
                          >
                            {showFullDescription ? "Read less" : "Read more"}
                          </Typography>
                        )}
                      </Box>
                    )}
                  </Typography>
                </Box>
                <Box
                  sx={{
                    pt: 3,
                    display: "flex",
                    flexDirection: "column",
                    gap: 1,
                  }}
                >
                  <Typography
                    variant="h5"
                    style={{
                      fontSize: "25px",
                      fontWeight: 600,
                      lineHeight: "30.26px",
                      textAlign: "left",
                      color: "#15224F",
                    }}
                  >
                    Others also{" "}
                    <span style={{ color: "#EF4F26" }}>Looked for</span>
                  </Typography>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      flexWrap: "nowrap",
                      width: "auto",
                      minWidth: "100%",
                    }}
                  >
                    {additonalProductsError ? (
                      <Box>
                        <Typography>No similar products found.</Typography>
                      </Box>
                    ) : (
                      <Box>
                        {!similarProducts ? (
                          <CircularProgress />
                        ) : (
                          <Box>
                            {similarProducts?.similarProducts.length > 5 ? (
                              <Box>
                                {showMore ? (
                                  <Box>
                                    <Grid container spacing={1}>
                                      {similarProducts.similarProducts.map(
                                        (product, index) => (
                                          <Grid
                                            item
                                            xs={6}
                                            sm={6}
                                            md={4}
                                            lg={3}
                                            key={index}
                                          >
                                            {" "}
                                            <ProductCard
                                              image={product.image}
                                              title={product.title}
                                              upc={product.upc}
                                              height={"25vh"}
                                            />
                                          </Grid>
                                        )
                                      )}
                                    </Grid>
                                  </Box>
                                ) : (
                                  <Box
                                    sx={{
                                      display: "flex",
                                      flexDirection: "row",
                                      flexWrap: "nowrap",
                                      overflowX: "auto",
                                    }}
                                  >
                                    {similarProducts.similarProducts
                                      .slice(0, 4)
                                      .map((product, index) => (
                                        <Box
                                          key={index}
                                          sx={{
                                            flexShrink: 0,
                                            width: "17vh",
                                            marginRight: 2,
                                          }}
                                          onClick={() => {
                                            setLoadingProductId(product.id);
                                            product.found = false;
                                            navigate(
                                              `/products/details/${product.id}`
                                            );
                                          }}
                                        >
                                          <ProductCard
                                            image={product.image}
                                            title={product.title}
                                            upc={product.id}
                                            height={"30vh"}
                                          />
                                        </Box>
                                      ))}
                                  </Box>
                                )}
                              </Box>
                            ) : (
                              <Box
                                sx={{
                                  overflowX: "auto",
                                  width: "100%",
                                  display: "flex",
                                  justifyContent: "left",
                                }}
                              >
                                {similarProducts.similarProducts
                                  .slice(0, 4)
                                  .map((product, index) => (
                                    <Box
                                      key={index}
                                      sx={{
                                        flexShrink: 0,
                                        width: "17vh",
                                        marginRight: 2,
                                        position: "relative", // Add position relative to the parent Box
                                      }}
                                      onClick={() => {
                                        setLoadingProductId(product.id); // Set loading state
                                        product.found = false;
                                        navigate(
                                          `/products/details/${product.id}`
                                        );
                                      }}
                                    >
                                      <ProductCard
                                        image={product.image}
                                        title={product.title}
                                        height={"30vh"}
                                      />
                                      {loadingProductId === product.id && (
                                        <Box
                                          sx={{
                                            position: "absolute",
                                            top: 0,
                                            left: 0,
                                            width: "100%",
                                            height: "100%",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            backgroundColor:
                                              "rgba(255, 255, 255, 0.7)",
                                            zIndex: 1,
                                          }}
                                        >
                                          <CircularProgress />
                                        </Box>
                                      )}
                                    </Box>
                                  ))}
                              </Box>
                            )}
                          </Box>
                        )}
                      </Box>
                    )}
                  </Box>
                </Box>
                {/*<Box
                  sx={{ pt: 3, display: "flex", flexDirection: "column", gap: 1 }}
                >
                  <Typography
                    variant="h5"
                    style={{
                      fontSize: "25px",
                      fontWeight: 600,
                      lineHeight: "30.26px",
                      textAlign: "left",
                      color: "#15224F",
                    }}
                  >
                    Related <span style={{ color: "#EF4F26" }}>Prompts</span>
                  </Typography>
                  <Box mt={1}>
                    {product.relatedPrompts &&
                      product.relatedPrompts.map((relatedPrompt, index) => (
                        <Chip
                          key={index}
                          label={relatedPrompt}
                          size="small"
                          sx={{ mr: 1.5, mb: 1, py: 2, px: 1 }}
                        />
                      ))}
                  </Box>
                </Box>*/}
                <Box
                  sx={{
                    pt: 3,
                    display: "flex",
                    flexDirection: "column",
                    gap: 1,
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      gap: 1,
                      justifyContent: "space-between",
                    }}
                  >
                    <Typography
                      variant="h5"
                      style={{
                        fontSize: "25px",
                        fontWeight: 600,
                        lineHeight: "30.26px",
                        textAlign: "left",
                        color: "#15224F",
                      }}
                    >
                      <span style={{ color: "#EF4F26" }}>Reviews</span>
                    </Typography>
                    <Box sx={{ display: "flex", flexDirection: "row" }}>
                      {reviews.reviews && reviews.reviews.length > 0 && (
                        <Rating
                          value={
                          //   reviews.reviews.reduce(
                          //   (sum, review) =>
                          //     sum +
                          //     Number(review.rating, 0) / reviews.reviews.length
                          // )
                          5
                        }
                          precision={0.5}
                          readOnly
                        />
                      )}
                      <Typography
                        variant="body2"
                        color="textSecondary"
                        sx={{
                          ml: 1,
                          mt: 0.5,
                          underline: "hover",
                          color: "#15224F",
                          cursor: "pointer",
                        }}
                      >
                        <b>
                          {/* {
                          // reviews.reviews.reduce(
                          //   (sum, review) =>
                          //     sum +
                          //     Number(review.rating, 0) / reviews.reviews.length
                          // )
                          4.5
                          } */}
                        </b>{" "}
                        <span style={{ color: "#3F3F3F", fontSize: "11px" }}>
                          (10 ratings)
                        </span>{" "}
                        {/* can add later if we want to */}
                        {/* <span style={{ color: "#15224F" }}>(See More)</span> */}
                      </Typography>
                    </Box>
                  </Box>
                  <Divider
                    variant="middle"
                    sx={{ width: "100%", margin: "none" }}
                  />
                  <Box mt={1}>
                    {reviews.reviews ? (
                      reviews.reviews
                        .slice(0, sliceSize)
                        .map((review, index) => (
                          <Box key={index} sx={{ mb: 1 }}>
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "flex-start",
                                px: 1,
                                pt: 2,
                              }}
                            >
                              {/* Placeholder for profile icon */}
                              <Avatar
                                sx={{
                                  bgcolor: "gray",
                                  width: "50px",
                                  height: "50px",
                                  mr: 2,
                                }}
                              />

                              <Box
                                sx={{
                                  flexGrow: 1,
                                  display: "flex",
                                  flexDirection: "column",
                                }}
                              >
                                <Box
                                  sx={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "flex-start",
                                  }}
                                >
                                  <Typography
                                    variant="h6"
                                    sx={{ fontSize: "14px", color: "#292825" }}
                                  >
                                    {review.author}
                                  </Typography>
                                  <Typography
                                    variant="caption"
                                    color="text.secondary"
                                  >
                                    {review.date_posted}
                                  </Typography>
                                </Box>
                                <Rating
                                  value={Number(review.rating)}
                                  precision={0.5}
                                  readOnly
                                />
                                <Typography
                                  variant="body1"
                                  sx={{
                                    my: 1,
                                    color: "#646260",
                                    fontSize: "14px",
                                  }}
                                >
                                  {review.review}
                                </Typography>
                              </Box>
                            </Box>
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "flex-end",
                                px: 1,
                                pb: 0.5,
                                "$:hover": { borderRadius: 1 },
                              }}
                            >
                              <IconButton
                                sx={{
                                  fontSize: "14px",
                                  gap: 1,
                                }}
                              >
                                <Icon
                                  icon={favoriteFilled}
                                  style={{
                                    color: "#EF4F26",
                                    height: "22px",
                                    width: "22px",
                                  }}
                                />
                                Like
                              </IconButton>
                              <IconButton sx={{ fontSize: "14px", gap: 1 }}>
                                <Icon
                                  icon="akar-icons:arrow-back"
                                  style={{ height: "22px", width: "22px" }}
                                />
                                Reply
                              </IconButton>
                            </Box>
                            <Divider
                              variant="middle"
                              sx={{ width: "100%", margin: "none" }}
                            />
                          </Box>
                        ))
                    ) : (
                      <Box sx={{ width: "100%" }}>
                        {[...Array(2)].map((_, index) => (
                          <Box key={index} sx={{ mb: 2 }}>
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "flex-start",
                                px: 1,
                                pt: 2,
                              }}
                            >
                              <Skeleton
                                variant="circular"
                                width={50}
                                height={50}
                                sx={{ mr: 2 }}
                              />
                              <Box sx={{ flexGrow: 1 }}>
                                <Skeleton
                                  variant="text"
                                  width="40%"
                                  height={20}
                                />
                                <Skeleton
                                  variant="text"
                                  width="20%"
                                  height={15}
                                />
                                <Skeleton
                                  variant="rectangular"
                                  width="100%"
                                  height={30}
                                  sx={{ mt: 1, borderRadius: 2, mb: 2 }}
                                />
                              </Box>
                            </Box>
                            <Divider
                              variant="middle"
                              sx={{ width: "100%", margin: "none" }}
                            />
                          </Box>
                        ))}
                      </Box>
                    )}
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      gap: 2,
                      alignItems: "center",
                      mb: 4,
                    }}
                  >
                    <IconButton
                      sx={{
                        width: "194px",
                        height: "53px",
                        borderRadius: "30px",
                        background: "#E8E8E8",
                        gap: 1,
                        "&:hover": {
                          background: "#E8E8E8",
                          opacity: 1,
                        },
                        ml: 2,
                        mt: 1,
                      }}
                    >
                      <Typography variant="h6" sx={{ color: "#205375" }}>
                        Write a Review
                      </Typography>
                    </IconButton>
                    <Typography
                      variant="h6"
                      sx={{
                        color: "#205375",
                        mt: 1,
                        textDecoration: expanded ? "underline" : "none",
                        cursor: "pointer",
                        "&:hover": {
                          textDecoration: "underline",
                          color: "#123456", // Optional: Change color on hover
                        },
                      }}
                      onClick={handleSeeMoreToggle}
                    >
                      {expanded ? "See less" : "See more"}
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      ) : (
        <Box>
          <ProductSkeletonLarge />
        </Box>
      )}
    </Container>
  );
};

export default DetailsLarge;
